
<template>
  <div style="height: 100%">
    <!-- <div class="header"></div> -->
    <div class="queriesMain">
      <div class="queriesMain-left">
        <Tabs class="a1" style="height: 100%" >
          <!-- 表结构 -->
          <TabPane class="a2"  label="表">

            <div class="menu-top">
              <Input
                v-model="tableValue"
                clearable
                placeholder="Filter..."
                style="width: 222px"
                @on-change="filterTab(tableValue)"
              />
              <div class="dbTitle">
                <div style="display: flex; align-items: center; column-gap: 5px;">
                  <h4>表</h4>
                  <span>({{ tableListArr.length }})</span>
                </div>
              </div>

            </div>
            <!-- menu -->
            <div
              class="menu"
              style="height: 100%"
            >
              <Menu theme="light"  @on-select="selectMenu" width="100%">
                <Submenu
                  v-for="(item, index) in tableListArr"
                  :name="item.tableName"
                >
                  <template slot="title">
                    <Icon type="svg" />
                    {{ item.tableName }}
                  </template>
                  <MenuItem
                    v-for="(items, ind) in item.rows"
                    :key="ind"
                    :name="item.tableName + '-' + items.propertyName"
                    @click="changeTitle(item)"
                    >{{ items.propertyName }}({{ items.dataType }})</MenuItem
                  >
                </Submenu>
              </Menu>
            </div>
          </TabPane>
          <!-- 文件目录 -->
          <TabPane class="a2"  label="目录">
            <div class="menu-top">
              <div class="dbTitle">
                <h4>
                  <Icon class="iconSize" type="ios-arrow-back" />
                  <span class="iconSize">/</span>
                  <Icon class="iconSize" type="ios-document" />
                </h4>
                <div class="dbTable-right">
                  <Poptip placement="left-start" width="200">
                    <Icon class="iconSize" type="md-add" />
                    <div class="api" slot="content">
                      <div @click="newSelect">
                        <Icon class="iconSize" type="ios-document-outline" />
                        新建查询
                      </div>
                      <div @click="modal1 = true">
                        <Icon class="iconSize" type="ios-folder-outline" />
                        新文件夹
                      </div>
                    </div>
                  </Poptip>
                  <!-- 添加目录 -->
                  <!-- @on-cancel="cancel" -->
                  <Modal
                    v-model="modal1"
                    title="创建目录"
                    @on-ok="createFiles"
                    okText="创建"
                    cancelText="取消"
                  >
                    <Form
                      ref="formValidate"
                      :model="formValidate"
                      label-position="right"
                      :rules="ruleValidate"
                    >
                      <FormItem prop="name">
                        <Input
                          v-model="formValidate.name"
                          placeholder="目录名称"
                        ></Input>
                      </FormItem>
                    </Form>
                  </Modal>
                </div>
              </div>
              <Input
                v-model="fileValue"
                clearable
                placeholder="Filter..."
                style="width: 222px"
                @on-change="filterFile(fileValue)"
              />
            </div>
            <!-- fileMenu -->
            <div
              class="fileMenu"
              style="overflow-y: scroll; height: 100%"
            >
              <ul>
                <li
                  v-for="item in fileListArr"
                  :key="item.id"
                  @click="selectFileItem(item)"
                  @contextmenu.prevent="rightClick(item)"
                >
                  <div class="fileItemSetting" v-show="item.show">
                    <div @click="updateFIle(item)">update</div>
                    <div @click="delItem(item)">delete</div>
                  </div>
                  <Icon
                    class="iconSize"
                    :type="
                      item.file ? 'ios-document-outline' : 'ios-folder-outline'
                    "
                  />
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <div class="queriesMain-content">
        <queriesMain ref="queriesMain"></queriesMain>
      </div>
      <div class="queriesMain-right">
        <Document />
      </div>
    </div>
  </div>
</template>
<script>
import queriesMain from "./components/queries-main.vue";
import Document from "./components/document.vue";
import api from "@/libs/api";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: { queriesMain, Document },
  data() {
    return {
      // isContextmenu: false,
      modal1: false,
      tableValue: "", //tab搜索内容
      fileValue: "", //file搜索内容
      formValidate: {
        name: "",
      }, //添加table 名字 描述
      selectStr: "",
      ruleValidate: {
        name: [
          {
            required: true,
            message: "Empty name",
            trigger: "blur",
          },
        ], //必填验证
      },
      subdirectoryList: [], //根据根目录查询子目录
      page: 1,
      pageSize: 10,
      tableListArr: [],
      fileListArr: [],
    };
  },
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
      tableList: (state) => state.customizedQueries.tableList,
      fileList: (state) => state.customizedQueries.fileList,
    }),
  },
  watch: {
    fileList(list) {
      this.fileListArr = list;
    },
  },
  mounted() {
    document.addEventListener("click", this.HiddenClick);
    this.filterTab();
    this.filterFile();
    this.fileListArr = this.fileList;
  },
  created() {
    // let param = {
    //   projectId: this.projectId,
    //   page: this.page,
    //   pageSize: this.pageSize,
    // };
    this.getTable(this.projectId);
    this.getFile(this.projectId);
    // this.getSaveStatement(param);
  },
  methods: {
    //
    ...mapActions([
      "getTable",
      "getFile",
      "getSaveStatement",
      "getSaveStatementAll",
    ]),
    // 选择表菜单
    selectMenu(active) {
      this.$refs.queriesMain.changeValue(active);
    },
    // 选择文件菜单
    selectFileItem(item) {
      item.file
        ? api.getSaveStatement(this.projectId, item.id).then((res) => {
            // 查询文件
            this.$refs.queriesMain.selectItem(res.data.fields);
            // this.$refs.queriesMain.selectItem(res.data.fields.list[0]);
          })
        : api.getFileList(this.projectId, item.id).then((res) => {
            // 查询文件夹
            // console.log(res, "11111");
            // this.subdirectoryList = res.data.fields.list;
          });
    },
    // 右键
    rightClick(item) {
      this.HiddenClick();
      item.show = true;
    },
    // 隐藏显示
    HiddenClick() {
      this.fileListArr.forEach((el) => {
        el.show = false;
      });
    },
    // 更新文件
    updateFIle(item) {
      this.selectFileItem(item);
    },
    // 删除
    delItem(item) {
      api.delFIle(this.projectId, item.id).then((res) => {
        if (res.data.status == 1) {
          this.getFile(this.projectId);
          // let param = {
          //   projectId: this.projectId,
          //   page: this.page,
          //   pageSize: this.pageSize,
          // };
          this.getSaveStatementAll(this.projectId);
          this.$Message.info("删除成功");
        }
      });
    },
    // 新建查询
    newSelect() {
      // window.location.reload();
      this.$refs.queriesMain.newQuery();
    },
    // 创建目录
    createFiles() {
      let params = {
        name: this.formValidate.name,
        description: "",
        parentId: "",
      };
      api.createCatalogue(this.projectId, params).then((res) => {
        if (res.data.status == 1) {
          this.getFile(this.projectId);
          this.$Message.info("创建成功");
        }
      });
    },
    // cancel() {
    //   this.$Message.info("Clicked cancel");
    // },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success("Success!");
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    filterTab(val) {
      setTimeout(() => {
        if (val) {
          this.tableListArr = this.tableList.filter(
            (item) =>
              item.cname.toLowerCase().indexOf(val.toLowerCase()) != -1 ||
              item.tableName.toLowerCase().indexOf(val.toLowerCase()) != -1
          );
        } else {
          this.tableListArr = this.tableList;
        }
      }, 1000);
    },

    filterFile(val) {
      if (val) {
        this.fileListArr = this.fileList.filter(
          (item) => item.name.toLowerCase().indexOf(val.toLowerCase()) != -1
        );
      } else {
        this.fileListArr = this.fileList;
      }
    },
  },
};
</script>
<style scoped>
/* .header {
  height: 8%;
  width: 100%;
} */

.ivu-menu-vertical .ivu-menu-item {
  padding: 4px 24px;
}

.queriesMain {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 100%;
  /* height: 92%; */
  height: 100% !important;
  display: grid;
  grid-template-columns: auto 1fr auto;
}
.queriesMain-left {
  width: 300px;
  background: #f8fafc;
  border: 1px #E5E7EB solid;
}

.queriesMain-content {
  background-color: #fff;
  overflow: auto;
}

.queriesMain-right {
  padding: 10px;
  background: #f9fafc;
  border: 1px #E5E7EB solid;
  /* overflow: auto; */
}

>>>.queriesMain-right .el-tree {
  background-color: #f9fafc;
}

.menu-top {
  height: 75px;
  width: 100%;
  padding: 0 20px;
}
.dbTitle {
  display: flex;
  padding: 10px 0;
  column-gap: 5px;
  align-items: center;
  justify-content: space-between;
}
.menu {
  overflow: auto;
}
.fileMenu ul {
  margin-left: 22px;
}
.fileMenu ul li {
  margin: 10px 0;
  position: relative;
}
.fileMenu ul li:hover {
  background: #ccc;
  /* color: #fff; */
}
.fileItemSetting {
  width: 120px;
  display: flex;
  height: 80px;
  position: absolute;
  top: 0;
  right: 10px;
  background: #fff;
  border: 1px solid #ccc;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 5;
}
.fileItemSetting div {
  height: 40px;
  width: 120px;
  text-align: center;
  line-height: 40px;
  border-bottom: 1px solid #ccc;
}
.fileItemSetting div:hover {
  background: #ccc;
  color: #fff;
}

.MenuItem {
  margin: 5px 0 5px 10px;
}
.MenuItem:hover {
  background: #f0f0f0;
}

.api div {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.api div:first-child {
  border-bottom: 1px solid #ccc;
}
.iconSize {
  font-size: 20px;
}


>>>.a1 .ivu-tabs-nav-scroll {
  display: flex;
  justify-content: center;

}

>>>.a1 .ivu-menu-light {
  background: #f8fafc;
}

>>>.a1 .ivu-tabs-bar {
  padding-top: 15px;
}
</style>






// WEBPACK FOOTER //
// src/views/customized-queries/customized-queries.vue